import React from 'react'
import PropTypes from 'prop-types'
import MEModal from '../../components/MEModal'
import { Button } from 'react-bootstrap'

const EditAssessmentModal = props => {
  return (
    <MEModal
      show={props.actModalOpen}
      close={props.openCloseActModal}
      title="Edit Assignment Title"
    >
      <div className="mb-4">
        <form onSubmit={e => e.preventDefault()}>
          <div className="mb-5 text-left mx-auto w-50">
            <h6>Name</h6>
            <input
              type="text"
              className="w-100 form-control form-control-sm"
              value={props.name}
              onChange={props.handleNameChange}
            />
          </div>
        </form>
        <div className="mx-auto w-50 text-center">
          <Button
            type="button"
            bsStyle="danger"
            className="btn-myed btn-danger-myed mr-4"
            onClick={props.editAct}
          >
            Save
          </Button>
          <Button
            type="button"
            bsStyle="default"
            className="btn-myed btn-default-myed"
            onClick={props.openCloseActModal}
          >
            Cancel
          </Button>
        </div>
      </div>
    </MEModal>
  )
}

export default EditAssessmentModal

EditAssessmentModal.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  actPk: PropTypes.string,
  canvasId: PropTypes.number,
  actModalOpen: PropTypes.bool,
  openCloseActModal: PropTypes.func,
  editAct: PropTypes.func,
  handleNameChange: PropTypes.func,
}
